import { render, staticRenderFns } from "./BrandSubscriptionHistory.vue?vue&type=template&id=7328223e&scoped=true&"
import script from "./BrandSubscriptionHistory.vue?vue&type=script&lang=ts&"
export * from "./BrandSubscriptionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSubscriptionHistory.vue?vue&type=style&index=0&id=7328223e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328223e",
  null
  
)

export default component.exports